// extracted by mini-css-extract-plugin
export var modalFooter = "_la-0";